import './style.scss';
import psl_actions from '../../libs/psl_actions.js';
import psl_ui from '../../libs/psl_ui.js';
import template from './template.pst';
import template_row from './template_row.pst';
import state from "../../state.js";

import {wait} from '../../libs/psl_polyfills.js';
import {rem_to_px} from '../../libs/helpers.js';

import CONFIG from '../../CONFIG.js';

psl_ui.templates.add('timeline',template);
psl_ui.templates.add('timeline_row',template_row);

const ease_out_quad = (x)=>(1 - Math.pow(1 - x, 3));

psl_actions.add('timeline.scroll.to',(e,date)=>{
	const timeline=psl_ui.DOM.controller(e.target);
	if(!timeline || (timeline.constructor!==Timeline)) return;

	timeline.scroll_to(date);
});

psl_actions.add('timeline.scroll.left',(e)=>{
	const timeline=psl_ui.DOM.controller(e.target);
	if(!timeline || (timeline.constructor!==Timeline)) return;

	state.submenu=Math.max(0,state.submenu-1);
});

psl_actions.add('timeline.scroll.right',(e)=>{
	const timeline=psl_ui.DOM.controller(e.target);
	if(!timeline || (timeline.constructor!==Timeline)) return;

	state.submenu=Math.min(timeline.data.submenu.length-1,state.submenu+1);
});

class Timeline{
	constructor(section_data){
		const {el, rpoints} = psl_ui.templates.render('timeline');

		this._rpoints=rpoints;
		this.view=el;
		this.view.controller=this;

		this.data=section_data;

		this._rpoints.wrapper.addEventListener('scroll',()=>{
			const is_mobile=!window.matchMedia('(min-width: 769px)').matches;
			if(is_mobile){
				if(this._render_scroll) return;
				const center=this._rpoints.wrapper.scrollTop+this._rpoints.wrapper.clientHeight/2;
				const lis=Array.from(this._rpoints.columns.querySelectorAll('li:not(.mobile_hidden)'));
				let li_at_center=null;
				for(const li of lis){
					const data=li.getAttribute('data-data');
					if(data===''||data===null) continue;
					if(li.offsetTop+li.offsetHeight>=center&&li.offsetTop<=center){
						li_at_center=li;
						break;
					}
				}
				if(!li_at_center) return;
				const year=+li_at_center.getAttribute('data-data');
				const submenu=this._data.submenu.find(({period})=> year>=+period[0]&&year<=+period[1]);
				if(!submenu) return;
				const index=this._data.submenu.indexOf(submenu);
				this._ignore_submenu=true;
				state.submenu=index;
				this._ignore_submenu=false;
				return;
			}
			if(this._render_scroll) return;
			const year = this._data.start+Math.round(this._rpoints.wrapper.scrollLeft/rem_to_px(20))+3;
			const submenu = this._data.submenu.find(({period})=> year>=+period[0]&&year<=+period[1]);
			if(!submenu) return;
			const index = this._data.submenu.indexOf(submenu);

			this._ignore_submenu=true;
			state.submenu=index;
			this._ignore_submenu=false;
		});

		this._rpoints.wrapper.addEventListener('pointerdown',(e)=>{
			if(!window.matchMedia('(min-width: 769px)').matches) return;
			// const target = e.target;
			// const interactive = target.closest('button, a, [data-action]');
			// if(interactive && interactive !== this._rpoints.wrapper){
			// 	return;
			// }
			this._pointer_start_x = e.clientX;
			this._scroll_start_x = this._rpoints.wrapper.scrollLeft;
			this._is_dragging = false;
			this._has_moved = false;
			this._pointer_id = e.pointerId;
			//this._rpoints.wrapper.setPointerCapture(e.pointerId);
		});

		this._rpoints.wrapper.addEventListener('pointermove',(e)=>{
			if(!window.matchMedia('(min-width: 769px)').matches || this._pointer_start_x === undefined || e.pointerId !== this._pointer_id) return;
			const delta_x = Math.abs(this._pointer_start_x - e.clientX);
			if(delta_x > 5){
				if(!this._is_dragging){
					psl_actions.break();
					this._is_dragging = true;
					this._has_moved = true;
					this._rpoints.wrapper.style.cursor = 'grabbing';
					this._rpoints.wrapper.style.userSelect = 'none';
				}
				this._rpoints.wrapper.scrollLeft = this._scroll_start_x + (this._pointer_start_x - e.clientX);
			}
		});

		this._rpoints.wrapper.addEventListener('pointerup',(e)=>{
			if(e.pointerId !== this._pointer_id) return;
			if(this._is_dragging){
				this._is_dragging = false;
				this._rpoints.wrapper.style.cursor = '';
				this._rpoints.wrapper.style.userSelect = '';
				e.preventDefault();
			}
			this._pointer_start_x = undefined;
			this._pointer_id = undefined;
			//this._rpoints.wrapper.releasePointerCapture(e.pointerId);
		});

		this._rpoints.wrapper.addEventListener('pointercancel',(e)=>{
			if(e.pointerId !== this._pointer_id) return;
			if(this._is_dragging){
				this._is_dragging = false;
				this._rpoints.wrapper.style.cursor = '';
				this._rpoints.wrapper.style.userSelect = '';
			}
			this._pointer_start_x = undefined;
			this._pointer_id = undefined;
			//this._rpoints.wrapper.releasePointerCapture(e.pointerId);
		});
	}

	on_submenu(){
		if(!this._ignore_submenu) this.scroll_to(+this.data.submenu[state.submenu].period[0]);
		this._render_period();
	}

	async show(){
		this.scroll_to(+this.data.submenu[state.submenu].period[0],0);
		this._render_period();
		this.view.classList.remove('hidden');
		await wait(350);
	}

	async hide(){
		this.view.classList.add('hidden');
		await wait(350);
	}

	set data(_){
		this._data=_;
		this._render();
	}

	get data(){
		return this._data;
	}

	_render(){
		this._rpoints.header.innerHTML=this._data.name||"";
		this._rpoints.columns.innerHTMl='';
		this.view.style.backgroundImage=`url("${CONFIG.backend_base_url}files/${this._data.bkg}")`;

		const spacer={date:'',cards:[]};
		const spacer_el=psl_ui.templates.render('timeline_row',spacer).el;
		spacer_el.classList.add('mobile_hidden');
		this._rpoints.columns.appendChild(spacer_el);

		for(let date=+this._data.start;date<=+this._data.end;date++){
			const cards=this._data.events.filter(card=>(+card.date)===date);
			const row_el=psl_ui.templates.render('timeline_row',{date,cards}).el;
			if(!cards.length) row_el.classList.add('mobile_hidden');
			this._rpoints.columns.appendChild(row_el);
		}

		const spacer_end_el=psl_ui.templates.render('timeline_row',spacer).el;
		spacer_end_el.classList.add('mobile_hidden');
		this._rpoints.columns.appendChild(spacer_end_el);

		this._render_period();
	}

	_render_period(){
		this._rpoints.period_name.innerHTML=this._data.submenu[state.submenu].name||"";
		this._rpoints.period_subname.innerHTML=this._data.submenu[state.submenu].subname||"";
	}

	scroll_to(date, duration = 800){
		let li=this._rpoints.columns.querySelector(`[data-data="${date}"]`);
		if(!li) return;

		if(!window.matchMedia('(min-width: 769px)').matches){
			const target_top=Math.max(0,li.offsetTop-this._rpoints.wrapper.offsetHeight/2+li.offsetHeight/2);
			const current_top=this._rpoints.wrapper.scrollTop;
			const delta_top=target_top-current_top;
			const start_time=Date.now();
			this._render_scroll=()=>{
				const progress=Math.min(1,(Date.now()-start_time)/duration);
				this._rpoints.wrapper.scrollTop=current_top+delta_top*ease_out_quad(progress);
				if(progress<1) return requestAnimationFrame(this._render_scroll);
				delete this._render_scroll;
			};
			this._render_scroll();
			return;
		}

		const target_position=li.offsetLeft-rem_to_px(20);
		const current_position = this._rpoints.wrapper.scrollLeft;
		const delta_position = target_position - current_position;
		const start_time = Date.now();

		this._render_scroll = ()=>{
			const progress = Math.min(1,(Date.now()-start_time)/duration);
			this._rpoints.wrapper.scrollLeft = current_position + delta_position * ease_out_quad(progress);
			if(progress<1) return requestAnimationFrame(this._render_scroll);
			delete this._render_scroll;
		}

		this._render_scroll();
	}
}

export default Timeline;
